import React, { Fragment, useRef } from 'react'

import Col from 'react-bootstrap/Col'

import { Payment } from './Payment'
import { CheckoutBottom } from './CheckoutBottom'
import { FlexTicketRedeem } from './FlexTicketRedeem'
import { trackAddPaymentInfo } from '../../../../../../utilities/tracking'
import { trackCheckoutStage } from '../../../../../../utilities/cartSessionTracking'

export default function Checkout({
  event,
  setStatus,
  intentId,
  pendingOrderId,
  cart,
  openModal,
  donationPricing,
  donationRequirementMet = true,
  isRefreshingIntent = false,
}) {
  const hasTrackedPaymentInfoRef = useRef(false)
  let order = sessionStorage.getItem('order')
  if (order) order = JSON.parse(order)

  const paymentDeclined = (err) => {
    openModal('Card declined', err)
  }

  const checkValid = (e) => {
    let paymentButton = document.getElementById('payment-btn')
    let paymentButtonDisabled = document.getElementById('payment-btn-disabled')

    if (e && e.complete) {
      if (!hasTrackedPaymentInfoRef.current) {
        const organization =
          cart?.event?.organization ||
          cart?.package?.organization ||
          cart?.flex_pack?.organization ||
          event?.organization
        trackAddPaymentInfo({
          organization,
          cart,
        })
        trackCheckoutStage('payment', { payment_info_entered: true }, cart?.id)
        hasTrackedPaymentInfoRef.current = true
      }
      paymentButton.classList.add('d-flex')
      paymentButton.classList.remove('d-none')
      paymentButtonDisabled.classList.add('d-none')
    } else {
      paymentButton.classList.add('d-none')
      paymentButtonDisabled.classList.remove('d-none')
      paymentButtonDisabled.classList.add('d-block')
    }
  }

  return (
    <Fragment>
      <Col>
        <FlexTicketRedeem
          cart={cart}
          pendingOrderId={pendingOrderId}
          donationAmount={donationPricing?.donationAmount}
        />
        <section>
          <Payment checkValid={checkValid} />
        </section>
        <CheckoutBottom
          setStatus={setStatus}
          intentId={intentId}
          pendingOrderId={pendingOrderId}
          paymentDeclined={paymentDeclined}
          cart={cart}
          donationPricing={donationPricing}
          donationRequirementMet={donationRequirementMet}
          isRefreshingIntent={isRefreshingIntent}
        />
      </Col>
    </Fragment>
  )
}
